(function () {
    'use strict';
    app.controller('storagemanagementController', ['storagemanagementService', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', function (storagemanagementService, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams) {


        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return
        }

        $scope.active = true;
        $scope.active1 = true;
        $scope.tab = 1;

        //$scope.setTab = function (newTab) {

        //    $scope.tab = newTab;
        //};

        $scope.isSet = function (tabNum) {

            return $scope.tab === tabNum;
        };

        $scope.filter = {
            eSpectraEmail: "",
            affiliationName: "",
            eSpectraFullName: ""
        };

        $scope.storageManagementValues = function () {
            $scope.searchByUser = {
                sortBy: '',
                reverse: false,
                currentPage: 1,
                itemsPerPage: 10,
                searchByName: "",
                searchByEmail: "",
                searchByPremium: true,
                searchByRestricted: true,
                searchByFree: true,
                searchByInstitutionName: '',
                totalRecords: 0,
                searchByAdministrator: true,
                searchByIndividualAccount: true,
                searchByInstitutionAccount: true
            }


            $scope.searchByInstitute = {
                sortBy: '',
                reverse: false,
                currentPage: 1,
                itemsPerPage: 10,
                searchByName: "",
                searchByEmail: "",
                searchByPremium: true,
                searchByRestricted: true,
                searchByFree: true,
                isAffiliation: 1,
                totalRecords: 0
            }
        }

        $scope.storageManagementValues();

        $scope.clearData = function () {
            $scope.storageManagementValues();
            $scope.storageDetailsAffiliation = [];
            $scope.storageDetails = [];
        }

        $scope.setPage = function (currentPage) {

            $scope.searchByUser.currentPage = currentPage;
            $scope.getStorageDetails($scope.searchByUser);
        }
        $scope.setInstitutePage = function (currentPage) {

            $scope.searchByInstitute.currentPage = currentPage;
            $scope.getStorageDetails($scope.searchByInstitute);
        }
        $scope.sort = function (sortBy, byAffiliation) {
            if ($scope.searchByUser.totalRecords < 1 && byAffiliation == 0) {
                return false;
            }
            else if ($scope.searchByInstitute.totalRecords < 1 && byAffiliation == 1) {

                return false;
            }
            $scope.searchByUser.sortBy = sortBy;
            $scope.searchByUser.reverse = !$scope.searchByUser.reverse;
            $scope.searchByUser.currentPage = 1;
            //$scope.searchByUser.isAffiliation = byAffiliation;
            $scope.getStorageDetails($scope.searchByUser);

        };
        $scope.getStorageDetails = function (data) {
            $scope.message = '';
            progressBarService.showProgressBar();

            var search = {
                eSpectraLastName: data.searchByName,
                eSpectraEmail: data.searchByEmail,
                eSpectraPrimaryAffiliationName: data.searchByInstitutionName,
                Restricted: data.searchByRestricted == true ? 1 : '-1',
                Free: data.searchByFree == true ? 0 : '-1',
                PremiumType: data.searchByPremium == true ? 2 : '-1',
                PageNo: data.currentPage,
                SortBy: data.sortBy,
                Reverse: data.reverse == true ? 'desc' : 'asc',
                ItemsPerPage: data.itemsPerPage,
                Administrator: data.searchByAdministrator ? '1' : '0',
                IndividualAccount: data.searchByIndividualAccount ? '1' : '0',
                InstitutionAccount: data.searchByInstitutionAccount ? '1' : '0'
            };

            storagemanagementService.getStorageDetails(search).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.storageDetails = [];
                    $scope.searchByUser.totalRecords = 0;
                    $scope.message = response.data.message;
                }
                else {
                    angular.forEach(response.data.dataManagementDetails, function (value1, i) {

                        response.data.dataManagementDetails[i].editable = false;
                        if (response.data.dataManagementDetails[i].totalAllocatedSize.indexOf('MB') > -1) {
                            response.data.dataManagementDetails[i].unit = 'MB';
                            response.data.dataManagementDetails[i].size = response.data.dataManagementDetails[i].totalAllocatedSize.replace('MB', '');
                        }
                        else if (response.data.dataManagementDetails[i].totalAllocatedSize.indexOf('GB') > -1) {
                            response.data.dataManagementDetails[i].unit = 'GB';
                            response.data.dataManagementDetails[i].size = response.data.dataManagementDetails[i].totalAllocatedSize.replace('GB', '');
                        }

                    });

                    //if (data.isAffiliation == 1) {

                    //    $scope.storageDetailsAffiliation = response.data.dataManagementDetails;
                    //    $scope.searchByInstitute.totalRecords = response.data.totalRecords;
                    //}
                    //else 
                    //if (data.isAffiliation == 0) {
                    $scope.storageDetails = response.data.dataManagementDetails;
                    $scope.searchByUser.totalRecords = response.data.totalRecords;
                    //}
                }

                progressBarService.hideProgressBar();
            });
        };

        if ($rootScope.eSpectraUserAnalyticsEmailID != undefined) {
            $scope.searchByUser.searchByEmail = $rootScope.eSpectraUserAnalyticsEmailID;
            $scope.getStorageDetails($scope.searchByUser);
        }


        $scope.numberOfPages = function () {
            return Math.ceil($scope.invitedDetails.length / $scope.invitationPageInfo.pageSize);
        }

        $scope.getDetailsOfInvitationsSent = function (data) {
            $scope.invitationPageInfo = {
                currentPage: 0,
                pageSize: 5
            }
            $scope.modalMessage = '';
            $scope.isModalError = false;
            progressBarService.showProgressBar();
            storagemanagementService.getinvitedUserDetail(data.eSpectraSubmitPersonID).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $('#DetailsOfInvitation').modal('show');
                }
                else {
                    $scope.invitedDetails = response.data;
                    $scope.numberOfPages();
                    $('#DetailsOfInvitation').modal('show');
                }
                progressBarService.hideProgressBar();
            });
        };

        $scope.editAffiliationStorage = function (index) {

            $scope.storageDetailsAffiliation[index].editable = !$scope.storageDetailsAffiliation[index].editable;
        }


        $scope.saveStorageDetails = function (index) {

            var data = $scope.storageDetailsAffiliation[index];

            var usedSize;

            if (data.usedSize.indexOf('MB') > -1) {
                usedSize = data.usedSize.substr(0, data.usedSize.length - 2);
            }
            else {
                usedSize = data.usedSize;
            }

            if (usedSize > data.size) {
                $scope.frmAffiliationStorage['updateInstStorage' + index].$invalid = true;
                $('#updateInstStorage' + index).addClass('border-red');
                return;
            }

            progressBarService.showProgressBar();

            storagemanagementService.saveStorageDetails(data).then(function (response) {
                if (response != null && response.data.message != undefined) {

                }
                else {

                    $scope.editAffiliationStorage(index);
                    $scope.storageDetailsAffiliation[index].totalAllocatedSize = data.size + data.unit;

                }

                progressBarService.hideProgressBar();
            });
        };


        $scope.editIndividualStorage = function (index) {

            $scope.storageDetails[index].editable = !$scope.storageDetails[index].editable;
        }


        $scope.saveStorageIndividualDetails = function (index) {

            var data = $scope.storageDetails[index];
            var usedSize;

            if (data.usedSize.indexOf('MB') > -1) {
                usedSize = data.usedSize.substr(0, data.usedSize.length - 2);
            }
            else {
                usedSize = data.usedSize;
            }

            if (usedSize > data.size) {
                $scope.frmIndividualStorage['updateIndStorage' + index].$invalid = true;
                $('#updateIndStorage' + index).addClass('border-red');
                return;
            }

            progressBarService.showProgressBar();

            storagemanagementService.saveStorageDetails(data).then(function (response) {
                if (response != null && response.data.message != undefined) {

                }
                else {

                    $scope.editIndividualStorage(index);
                    $scope.storageDetails[index].totalAllocatedSize = data.size + data.unit;

                }

                progressBarService.hideProgressBar();
            });
        };

        $scope.onKeyPress = function (event, data) {
            if (event.keyCode == 13) {
                $scope.getStorageDetails(data);
                event.preventDefault();
            }
        };

        $scope.displayDownloadReportPopup = function () {
            $scope.abbreviatedReport = true;
            $scope.fullReport = false;
            $('#downloadReportDialog').modal({ backdrop: 'static', keyboard: false });
        }
        //$scope.exportReportData = function () {

        //    progressBarService.showProgressBar();
        //    var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
        //    today = new Date();
        //    dd = today.getDate();
        //    mm = today.getMonth() + 1; //January is 0!

        //    yyyy = today.getFullYear();
        //    if (dd < 10) {
        //        dd = '0' + dd;
        //    }
        //    if (mm < 10) {
        //        mm = '0' + mm;
        //    }
        //    currentDate = mm + '/' + dd + '/' + yyyy;

        //    storagemanagementService.getStorageDetailsReport($scope.searchByUser).then(function (response) {
        //        if (response != null && response.data.message != undefined) {
        //            $scope.message = response.data.message;
        //            $scope.isError = true;
        //            $scope.isSuccess = false;
        //            //$timeout(hideMessage, 10000);
        //        }
        //        else {
        //            var csv = convertArrayOfObjectsToCSV({
        //                data: response.data.dataManagementDetailsExport
        //            });

        //            BlobDownloadCSV('UserAnalyticsReport_' + currentDate + '.csv', csv)

        //        }

        //        progressBarService.hideProgressBar();
        //    });
        //}


        //function convertArrayOfObjectsToCSV(args) {

        //    var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

        //    data = args.data || null;
        //    if (data == null || !data.length) {
        //        return null;
        //    }

        //    columnDelimiter = args.columnDelimiter || ',';
        //    lineDelimiter = args.lineDelimiter || '\n';


        //    keys = Object.keys(data[0]).slice(1);

        //    headers = ["Email Address",
        //        "Name",
        //        "Affiliation",
        //        "Capacity Available",
        //        "Capacity Used",
        //        "No. Of Files",
        //        "User Type",
        //        "Role Type",
        //        "Create Date",
        //        "Start Date",
        //        "End Date"]

        //    result = 'Report Name' + columnDelimiter + "User Unalytics Report" + lineDelimiter;

        //    result += headers.join(columnDelimiter);
        //    result += lineDelimiter;

        //    data.forEach(function (item) {

        //        ctr = 0;
        //        keys.forEach(function (key) {
        //            if (ctr > 0) result += columnDelimiter;

        //            result += item[key];
        //            ctr++;
        //        });
        //        result += lineDelimiter;
        //    });

        //    return result;
        //}

    }]);
})();
app.filter('startFrom', function () {
    return function (input, start) {
        start = +start; //parse to int
        return input.slice(start);
    }
});